export const ALLOW_COOKIES_STATUS = 'ALLOW_COOKIES_STATUS';
